import React from "react";
import useToken from "../useToken";
import Login from "../Login";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Register from "../Register";
import Home from "../Home";
import TTCheck from "../steps/TTCheck";
import TfCheckSocket from "../steps/TfCheckSocket";
import TtDefinitive from "../steps/TtDefinitive";
import TFDefinitive from "../steps/TFDefinitive";
import TTOneSocket from "../steps/TTOneSocket";
import TFStandardRevo from "../steps/TFStandardRevo";
import TTStandardRevo from "../steps/TTStandardRevo";
import PatientReview from "../steps/PatientReview";
import TFOneSocket from "../steps/TFOneSocket";
import Bilateral from "../steps/Bilateral";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../pages/NotFound";
import OneSocketPatientReview from "../steps/OneSocketPatientReview";
import DefinitiveReview from "../steps/DefinitiveReview";
import InternalReview from "../steps/InternalReview";
import TTXtremitySocket from "../steps/TTXtremitySocket";
import XtremityReview from "../steps/XtremityReview";
import KneeBundle from "../steps/KneeBundle";
import KneeBundleReview from "../steps/KneeBundleReview";
import LinerBundle from "../steps/LinerBundle";
import SimpleCartReview from "../steps/SimpleCartReview";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Routing = () => {
  const { setToken } = useToken();

  const url = useLocation();
  const currentLocation = url.pathname;
  const split = currentLocation.split("-");
  
  let query = useQuery();

  console.log(currentLocation);

  return (
    <>
      {/* {!isRegisterPage && !isLoginPage && !isNotFoundPage && <Header />} */}
      <Routes>
        {split.length > 1 && (
          <Route
            path={currentLocation}
            x
            element={
              <ProtectedRoute>
                <Bilateral url={split[0]} split={split[1]} formId={split[1]} />
              </ProtectedRoute>
            }
          />
        )}

        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/login`}
          element={<Login setToken={setToken} />}
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/register`}
          element={<Register />}
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/`}
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/ttchecksocket`}
          element={
            <ProtectedRoute>
              <TTCheck />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/liners`}
          element={
            <ProtectedRoute>
              <LinerBundle />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/internalsummary`}
          element={
            <InternalReview 
              formTypeId={query.get("f")}
              uniqueId={query.get("u")}
              formName="Check Socket Summary"
              handleError={(e)=>{console.log(e)}}
            />
          }
        />

        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/summary`}
          element={
            ( (query.get("f") === "3" || query.get("f") === "4") ? //TF or TT Check Sockets
              <PatientReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="Check Socket Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "5" || query.get("f") === "6") ? //TF or TT Definitive Sockets
              <DefinitiveReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="Definitive Socket Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "7" || query.get("f") === "8") ? //TF or TT One Sockets
              <OneSocketPatientReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="One® Socket Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "11") ? //Xtremity TT
            <XtremityReview
              formTypeId={query.get("f")}
              uniqueId={query.get("u")}
              formName="Xtremity Socket Review"
              handleNext={()=>{return}}
              handleBack={()=>{return}}
              handleError={(e)=>{console.log(e)}}
            />
            : (query.get("f") === "13") ? //Knee Bundle
            <KneeBundleReview
              formTypeId={query.get("f")}
              uniqueId={query.get("u")}
              formName="Knee Bundle Review"
              handleNext={()=>{return}}
              handleBack={()=>{return}}
              handleError={(e)=>{console.log(e)}}
            />
            : (query.get("f") === "14") ? //Liner Bundle
            <SimpleCartReview
              formTypeId={query.get("f")}
              uniqueId={query.get("u")}
              formName="Liner Order Review"
              handleNext={()=>{return}}
              handleBack={()=>{return}}
              handleError={(e)=>{console.log(e)}}
            />
            : <NotFound /> //Other
            )
          }
        />

        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/tfchecksocket`}
          element={
            <ProtectedRoute>
              <TfCheckSocket />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/ttdefinitive`}
          element={
            <ProtectedRoute>
              <TtDefinitive />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/tfdefinitive`}
          element={
            <ProtectedRoute>
              <TFDefinitive />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/tfstandardrevo`}
          element={
            <ProtectedRoute>
              <TFStandardRevo />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/ttstandardrevo`}
          element={
            <ProtectedRoute>
              <TTStandardRevo />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/ttonesocket`}
          element={
            <ProtectedRoute>
              <TTOneSocket />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/tfonesocket`}
          element={
            <ProtectedRoute>
              <TFOneSocket />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/ttxtremity`}
          element={
            <ProtectedRoute>
              <TTXtremitySocket />
            </ProtectedRoute>
          }
        />

        <Route path={`${process.env.REACT_APP_ORDER_FORM}/kneebundle`}
          element={
            <ProtectedRoute>
              <KneeBundle />
            </ProtectedRoute>
          }
        />

        <Route
          path={`*`}
          element={
            <ProtectedRoute>
              <Navigate to={`${process.env.REACT_APP_ORDER_FORM}/`} />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${process.env.REACT_APP_ORDER_FORM}/*`}
          element={
            <ProtectedRoute isNotFound={true}>
              <NotFound />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <PageController formTypeId={parseInt(formTypeId)} uniqueId={uniqueId} /> */}
    </>
  );
};

export default Routing;
